import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PageParams } from 'src/app/core/models/page-params.model';
import { ISaleOrder } from '../../../models/sale-order.interface';
import { SaleOrderService } from '../../../services/sale-order.service';
import { CheckpointsListPopupComponent } from './checkpoints-list-popup/checkpoints-list-popup.component';

@Component({
  selector: 'eci-checpoints-list',
  templateUrl: './checpoints-list.component.html',
  styleUrls: ['./checpoints-list.component.scss']
})
export class CheckpointsListComponent implements OnInit {

  pageParams: PageParams = new PageParams();

  @Input() info: ISaleOrder;
  @Input() isCreateMode: boolean = true;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  pageChanged(e: PageParams): void {
    this.pageParams.pageIndex = e.pageIndex;
    this.pageParams.pageSize = e.pageSize;
    // this.getList(e.pageIndex + 1, e.pageSize);
  }
  
  constructor(
    private saleOrderSvc: SaleOrderService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  displayedColumns: string[] = [
    'checkpointDate',
    'location',
    'subStatus', // TODO MAYBE NEED TO CHANGE TO ENUM
    'message',
  ];

  openDialogList(tracking): void {
    if (!tracking?.aftershipId) return;

    this.saleOrderSvc.getSaleOrderCheckpoints(tracking?.id).subscribe(values => {
      const dialogRef = this.dialog.open(CheckpointsListPopupComponent);

      dialogRef.componentInstance.dataSource = new MatTableDataSource<any>(values);
      dialogRef.componentInstance.trackingId = tracking?.id;
    })
  }
}
